export default function (methods) {
    return {
        stream: transformer(methods)
    };
}
export function transformer(methods) {
    return function (stream) {
        var s = new TransformStream;
        for (var key in methods)
            s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() { }
TransformStream.prototype = {
    constructor: TransformStream,
    point: function (x, y) { this.stream.point(x, y); },
    sphere: function () { this.stream.sphere(); },
    lineStart: function () { this.stream.lineStart(); },
    lineEnd: function () { this.stream.lineEnd(); },
    polygonStart: function () { this.stream.polygonStart(); },
    polygonEnd: function () { this.stream.polygonEnd(); }
};
